/* eslint-disable no-underscore-dangle */
import { InnerAction } from './InnerAction';

export class ClickInnerAction extends InnerAction {
  override activate(): void {
    super.activate(null!);
  }
}
